/**
 * @generated SignedSource<<2cc1ef188b95546e4443efb1306c5b4c>>
 * @relayHash 8e37c7e78a4c9344da5d75b4bb2c4723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3afa3bdd23eca02e6db0cb04fc94e4b55b2235634f681e30315c40b7cebf332e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FormEditQuery } from './FormEditQuery.graphql';

const node: PreloadableConcreteRequest<FormEditQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3afa3bdd23eca02e6db0cb04fc94e4b55b2235634f681e30315c40b7cebf332e",
    "metadata": {},
    "name": "FormEditQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
